module.exports = __webpack_public_path__ + "922f986a.png";